import React from "react";
import classNames from "classnames";
import { TEXT_CLASS_NAME } from "../Text";
import styles from "./SemiboldBody.module.scss";

type Props = {
  /**
   * Controls the underlying HTML tag that is rendered.
   * ex: `h1`, `span`, `p` etc.
   */
  as?: keyof JSX.IntrinsicElements;

  /** *Additional* classnames */
  className?: string;
} & React.HTMLAttributes<HTMLOrSVGElement>;

/**
 * This should be used anywhere you need the SemiboldBody text style.
 *
 * For semantics and SEO purposes, you can control the underlying HTML that gets rendered using the `as` prop.
 * */
const SemiboldBody = ({ as: As = "p", className, ...props }: Props) => (
  <As
    {...props}
    className={classNames(TEXT_CLASS_NAME, styles.semiboldBody, className)}
  />
);

export default SemiboldBody;
